export const backend_url = "https://stocksup.onrender.com"
//export const backend_url = "http://localhost:5000";
export const initialstocks = 20000;
